import Switch from "../list-management/switch";
import { getValue } from "@utils/lodash";
import EntitySwitch from "./switch";

export default function EntityMappingOptions(props: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let selected_id = getValue(
    params,
    `level${getValue(props, `parent_info.group_level`, "")}`,
    ""
  )
    ? getValue(
        params,
        `level${getValue(props, `parent_info.group_level`, "")}`,
        ""
      ).split("_")[0]
    : "";

  return (
    <div
      className={`list-managemnet-wrapper__country-items__choicelist px-3 d-flex align-items-center justify-content-between 
			${selected_id == getValue(props, `item.id`, "") ? "active" : ""}`}
    >
      <div
        className="p-3 w-75 d-flex align-items-center gap-2 cursor-pointer"
        onClick={() =>
          props.handleClickEntity(
            getValue(props, `item.id`, ""),
            getValue(props, `parent_info.id`, ""),
            getValue(props, `parent_info.group_level`, "")
          )
        }
      >
        {getValue(props, "parent_info.group_level", "") === 1 &&
        getValue(props, "item.entity_logo", "") ? (
          <img
            src={getValue(props, "item.entity_logo", "")}
            width={24}
            height={24}
            className="img-fluid"
            alt="entity_logo"
          />
        ) : null}

        <h6 className="mb-0 list-managemnet-wrapper__country-items-title">
          {getValue(props, `item.entity_name`, "")}
        </h6>
      </div>

      <div className="list-managemnet-wrapper__country-items-alter d-flex align-items-center">
        {getValue(props, `permissions`, []).includes("update") && (
          <img
            src="/images/list-management/country/edit-icon.svg"
            width={24}
            height={24}
            className="img-fluid"
            onClick={(e) =>
              props.handleEditEntity(
                e,
                getValue(props, `item`, ""),
                getValue(props, `parent_index`, null),
                getValue(props, `index`, null),
                getValue(props, `parent_info`, "")
              )
            }
          />
        )}
        {/* <img
					src="/images/list-management/country/delete-icon.svg"
					className="img-fluid"
					width={24}
					height={24}
					onClick={(e) =>
						props.handleDeleteEntity(e,
							getValue(props, `item`, ""),
							getValue(props, `parent_info.id`, ""),
							getValue(props, `parent_index`, null),
							getValue(props,`selected_id`,'')
						)
					}
				/> */}
        {getValue(props, `permissions`, []).includes("update") && (
          <EntitySwitch
            is_active={getValue(props, `item.is_active`, "")}
            onChange={props.handleChangeStatus}
            id={getValue(props, `item.id`, "")}
            parent_id={getValue(props, `parent_info.id`, "")}
            parent_index={getValue(props, `parent_index`, null)}
          />
        )}
      </div>
      {/* } */}
    </div>
  );
}
